import { themeTokens } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { k8sIconStyles } from "~/areas/projects/components/Observability/K8ResourceIcons/k8sIconStyles";
export function IngressIcon() {
    return (<svg className={k8sIconStyles} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M27.4926 31.1059H21.3007L7.88211 14.3198H4V8.82542H10.3119L23.7363 25.6115H27.4926V21.2664L36 28.3559L27.4926 35.4511V31.1059ZM20.7404 18.139L23.7363 14.3884H27.4926V18.7336L36 11.6441L27.4926 4.54883V8.89403H21.3007L17.3272 13.8681L20.7404 18.139ZM10.9294 21.861L7.88211 25.6802H4V31.1745H10.3119L14.3427 26.1318L10.9294 21.861Z" fill={themeTokens.color.icon.tertiary}/>
        </svg>);
}
